// extracted by mini-css-extract-plugin
module.exports = {"Loader":"SpinnerDark_Loader__1Y50G","load6":"SpinnerDark_load6__1SGdk","round":"SpinnerDark_round__3MpXY"};